import * as React from "react";
import { useState } from "react";
import { DatePicker } from "../../../../../../react-core/Datepicker/DatePicker";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { SelectEditor } from "../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../react-core/Html/TextBoxEditor";
import { CompanySearchClient } from "../../../../../../Wrap/Api/Company/CompanySearch";
import { NetworkHistoryClient } from "../../../../../../Wrap/Api/Network/NetworkHistory";
import { CustomerType } from "../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { AccountType } from "../../../../../../Wrap/Constants/Enums/Domain/AccountType";
import { CompanyDetailSort } from "../../../../../../Wrap/Constants/Enums/Domain/CompanyDetailSort";
import { CustomerStatus } from "../../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { FirmType } from "../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { EntityType } from "../../../../../../Wrap/Constants/Enums/EntityType";
import { NetworkType } from "../../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { RoleType } from "../../../../../../Wrap/Constants/Enums/RoleType";
import { AccountStatus } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { Adviser } from "../../../../../../Wrap/Models/Domains/Adviser/Adviser";
import { CompanySummary } from "../../../../../../Wrap/Models/Models/Company/CompanySummary";
import { NetworkHistoryModel } from "../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { AdviserWizardAction } from "../../../../../Admin/Adviser/Actions/AdviserWizardAction";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { ContentDatePicker, ACCEPT_DATE_FORMATS } from "../../../../../Shared/Entities/Constants/DateConstants";
import { SearchInput } from "../../../../../Shared/SearchInput/SearchInput";
import { IBasicSearchQuery } from "../Action/AccountSearchAction";
import { ICustomerSearchQuery } from "../Action/CustomerSearchAction";
import { IOrganisationSearchQuery } from "../Action/OrganisationSearchAction";
import {
    AccountNumberMinLengthValidationErrorMessage,
    accountStatusMap,
    accountStatusMapSorted,
    ALL,
    ALL_NON_WRAP,
    ALL_WRAP,
    clientTypeEnum,
    individualClientStatus,
    organisationStatusMap,
    organisationTypeArray,
    organisationTypeMap,
    RoleTypeMap,
    individualClientStatusSorted,
    organisationStatusMapSorted,
} from "../Resource/Content";

interface IClientAdvancedSearchProps {
    onSearch: (query: IOrganisationSearchQuery | ICustomerSearchQuery | IBasicSearchQuery) => void;
    isSearching: boolean;
    clientType: clientTypeEnum;
}

export const ClientAdvancedSearch = (props: IClientAdvancedSearchProps) => {
    const [customerStatus, setCustomerStatus] = useState(CustomerStatus.Active);
    const [organisationStatus, setOrganisationStatus] = useState(CustomerStatus.Active);
    const [status, setStatus] = useState(Number(AccountStatus.Active));
    const [organisationType, setorganisationType] = useState(CustomerType.NotSpecified);
    const [name, setName] = useState("");
    const [firstname, setFirstName] = useState("");
    const [lastname, setLastName] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [company, setCompany] = useState<CompanySummary>(null);
    const [network, setNetwork] = useState<NetworkHistoryModel>(null);
    const [adviserList, setAdviserList] = useState([]);
    const [adviser, setAdviser] = useState<Adviser>(null);
    const [displayNetworkSearch, setDisplayNetworkSearch] = useState(false);
    const [displayCompanySearch, setDisplayCompanySearch] = useState(false);
    const [clAccountId, setClAccountId] = useState("");
    const [customerRole, setCustomerRole] = useState(RoleType.NotSpecified);
    const { clientType } = props;

    React.useEffect(() => {
        const networkClient = new NetworkHistoryClient();
        networkClient.get(null, NetworkType.Unknown, null, null, null, false, 10, 1).onSuccess((result) => {
            if (result.TotalRows > 1) {
                setDisplayNetworkSearch(true);
            }
        });

        const companyClient = new CompanySearchClient();
        companyClient
            .get(null, null, FirmType.All, null, null, null, true, 1, 10, CompanyDetailSort.CompanyName,false)
            .onSuccess((result) => {
                if (result.TotalNumberOfResults > 1) {
                    setDisplayCompanySearch(true);
                } else if (result.TotalNumberOfResults == 1) {
                    getClientAllowedAdvisers(null, result.PageOfResults[0].CompanyCode);
                    setCompany(result.PageOfResults[0]);
                }
            });
    }, []);

    const getClientAllowedAdvisers = (network, company) => {
        if (CommonHelper.isNullOrEmpty(company) && CommonHelper.isNullOrEmpty(network)) {
            setAdviserList([]);
        } else {
            AdviserWizardAction.getAdviser(
                { Company: company, Network: network, CurrentPage: 1, ResultsPerPage: 999 },
                (result) => {
                    setAdviserList(result.Results);
                }
            );
        }
    };

    const isValid = () => {
        // Account number minlength is 3
        if (clAccountId && clAccountId !== "") {
            return clAccountId.length && clAccountId.length >= 3;
        }

        return true;
    };

    const networkClient = new NetworkHistoryClient();
    const companyClient = new CompanySearchClient();
    return (
        <>
            <div>
                <div>
                    <div className="row">
                        {displayNetworkSearch && (
                            <div className="col-6">
                                <SearchInput
                                    apiClient={(v) => {
                                        return networkClient.get(
                                            null,
                                            NetworkType.Unknown,
                                            v,
                                            null,
                                            null,
                                            false,
                                            20,
                                            1
                                        );
                                    }}
                                    onClick={(v) => {
                                        getClientAllowedAdvisers(v?.Network, null);
                                        setNetwork(v);
                                        setCompany(null);
                                        setAdviser(null);
                                    }}
                                    resultKey="networks"
                                    getText={(v: NetworkHistoryModel) => v.NetworkName}
                                    label={"Network"}
                                    value={network?.NetworkName}
                                />
                            </div>
                        )}
                        {displayCompanySearch && (
                            <div className="col-6">
                                <SearchInput
                                    apiClient={(v) => {
                                        return companyClient.get(
                                            null,
                                            v,
                                            FirmType.All,
                                            null,
                                            network?.Network,
                                            null,
                                            true,
                                            1,
                                            20,
                                            CompanyDetailSort.CompanyName,
                                            false
                                        );
                                    }}
                                    resultKey={"PageOfResults"}
                                    onClick={(v) => {
                                        getClientAllowedAdvisers(network?.Network, v?.CompanyCode);
                                        setCompany(v);
                                        setAdviser(null);
                                    }}
                                    getText={(v: CompanySummary) => v.CompanyName}
                                    label={"Company"}
                                    value={company?.CompanyName}
                                />
                            </div>
                        )}
                    </div>
                    <div className="row">
                        {clientType == clientTypeEnum.Individual ? (
                            <>
                                <div className="col-12 col-md-3 col-sm-6">
                                    <TextBoxEditor
                                        label="First name"
                                        onChange={(v) => setFirstName(v)}
                                        value={firstname}
                                        maxLength={100}
                                    />
                                </div>
                                <div className="col-12 col-md-3 col-sm-6">
                                    <TextBoxEditor
                                        label="Surname"
                                        onChange={(v) => setLastName(v)}
                                        value={lastname}
                                        maxLength={100}
                                    />
                                </div>
                            </>
                        ) : (
                            <div className="col-12 col-md-3 col-sm-6">
                                <TextBoxEditor label="Name" onChange={(v) => setName(v)} value={name} maxLength={100} />
                            </div>
                        )}
                        <div className="col-12 col-md-3 col-sm-6">
                            <TextBoxEditor
                                label="Account number"
                                onChange={(v) => setClAccountId(v)}
                                value={clAccountId}
                                maxLength={15}
                                minLengthValidation={{
                                    errorMessage: AccountNumberMinLengthValidationErrorMessage,
                                    value: 3,
                                }}
                            />
                        </div>
                        <div className="col-12 col-md-3 col-sm-6">
                            {clientType == clientTypeEnum.Individual && (
                                <SelectEditor
                                    id="customerStatus"
                                    label="Status"
                                    options={individualClientStatusSorted}
                                    getText={(v) => {
                                        return individualClientStatus[v];
                                    }}
                                    selected={customerStatus}
                                    onChange={(v) => setCustomerStatus(v)}
                                />
                            )}
                            {clientType == clientTypeEnum.Organisation && (
                                <SelectEditor
                                    label="Status"
                                    options={organisationStatusMapSorted}
                                    getText={(v) => {
                                        return organisationStatusMap[v];
                                    }}
                                    selected={organisationStatus}
                                    onChange={(v) => setOrganisationStatus(v)}
                                />
                            )}
                            {clientType == clientTypeEnum.Consolidated && (
                                <SelectEditor
                                    id="Status"
                                    getText={(v) => {
                                        return v == ALL
                                            ? "All"
                                            : v == ALL_WRAP
                                            ? "All Wrap"
                                            : v == ALL_NON_WRAP
                                            ? "All Non Wrap"
                                            : accountStatusMap[accountStatusMapSorted[v]];
                                    }}
                                    selected={status}
                                    onChange={(v) => setStatus(v)}
                                    label="Status"
                                    options={[ALL, ALL_WRAP, ALL_NON_WRAP].concat(
                                        Object.keys(accountStatusMapSorted).map((ele) => Number(ele))
                                    )}
                                />
                            )}
                        </div>
                        {clientType == clientTypeEnum.Organisation && (
                            <div className="col-12 col-md-3 col-sm-6">
                                <SelectEditor
                                    id="organisationType"
                                    label="Organisation type"
                                    options={organisationTypeArray}
                                    getText={(v) => {
                                        return organisationTypeMap[v];
                                    }}
                                    selected={organisationType}
                                    onChange={(v) => setorganisationType(v)}
                                />
                            </div>
                        )}
                        <div className="col-12 col-md-3 col-sm-6">
                            <SelectEditor
                                id="Adviser"
                                label="Adviser"
                                options={[null].concat(adviserList)}
                                getText={(v) => {
                                    return v ? v.Name : "All";
                                }}
                                selected={adviser}
                                onChange={(v) => setAdviser(v)}
                            />
                        </div>
                        <div className="col-12 col-md-3 col-sm-6">
                            {clientType == clientTypeEnum.Individual && (
                                <SelectEditor
                                    id="accountRole"
                                    label="Account role"
                                    cssWrapper="mb-0"
                                    options={Object.keys(RoleTypeMap).map((ele) => Number(ele))}
                                    getText={(v) => {
                                        return RoleTypeMap[v];
                                    }}
                                    selected={customerRole}
                                    onChange={(v) => setCustomerRole(v)}
                                />
                            )}
                        </div>
                        <div className="col-12 col-md-3 col-sm-6">
                            {clientType == clientTypeEnum.Individual && (
                                <DatePicker
                                    label={"Date of birth"}
                                    cssWrapper="mb-0"
                                    selected={dateOfBirth}
                                    alwaysValidateOnUpdate={false}
                                    atMost={{
                                        value: new Date(),
                                        errorMessage: ContentDatePicker.CannotBeInTheFuture,
                                    }}
                                    showYearDropdown={true}
                                    onChange={(d) => {
                                        setDateOfBirth(d);
                                    }}
                                    todayButton={ContentDatePicker.Today}
                                    isClearable={true}
                                    dateFormat={ContentDatePicker.DateFormat}
                                    acceptDateFormats={ACCEPT_DATE_FORMATS}
                                />
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-right">
                            <button
                                className={`btn primary mb-0 ${props.isSearching ? "is-busy" : ""}`}
                                onClick={() => {
                                    if (!isValid()) {
                                        return;
                                    }
                                    let query = null;
                                    if (clientType == clientTypeEnum.Individual) {
                                        let entityType = null;
                                        let entityID = null;
                                        if (adviser) {
                                            entityType = EntityType.Advisor;
                                            entityID = HierarchyIdHelper.generateHierarchyId(adviser.HierarchyId)
                                                .entityId;
                                        } else if (company) {
                                            entityType = EntityType.Company;
                                            entityID = HierarchyIdHelper.generateHierarchyId(company.HierarchyId)
                                                .entityId;
                                        } else if (network) {
                                            entityType = EntityType.Network;
                                            entityID = network.NetworkId;
                                        }

                                        query = {
                                            firstname: firstname,
                                            lastname: lastname,
                                            customerStatus: customerStatus,
                                            dateOfBirth: dateOfBirth,
                                            clAccountId: clAccountId != "" ? clAccountId.split("-")[0] : null,
                                            customerRole: customerRole,
                                            visibleToAdviserId: null,
                                            entityId: entityID,
                                            entityType: entityType,
                                        } as ICustomerSearchQuery;
                                    }
                                    if (clientType == clientTypeEnum.Organisation) {
                                        let entityType = null;
                                        let entityID = null;
                                        if (adviser) {
                                            entityType = EntityType.Advisor;
                                            entityID = HierarchyIdHelper.generateHierarchyId(adviser.HierarchyId)
                                                .entityId;
                                        } else if (company) {
                                            entityType = EntityType.Company;
                                            entityID = HierarchyIdHelper.generateHierarchyId(company.HierarchyId)
                                                .entityId;
                                        } else if (network) {
                                            entityType = EntityType.Network;
                                            entityID = network.NetworkId;
                                        }
                                        query = {
                                            organisationStatus: organisationStatus,
                                            organisationName: name,
                                            clAccountId: clAccountId != "" ? clAccountId.split("-")[0] : null,
                                            organisationType: organisationType,
                                            entityId: entityID,
                                            entityType: entityType,
                                        } as IOrganisationSearchQuery;
                                    }
                                    if (clientType == clientTypeEnum.Consolidated) {
                                        query = {
                                            accountName: name,
                                            accountNum: clAccountId,
                                            status: status,
                                            accountType: AccountType.Consolidated,
                                            network: network?.NetworkName,
                                            company: company?.CompanyName,
                                            advCode: adviser?.AdvCode,
                                        } as IBasicSearchQuery;
                                    }
                                    props.onSearch(query);
                                }}
                            >
                                Search
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
